_ = require 'underscore'
Promise = require 'bluebird'
PluginCardButtonsView = require 'app/scripts/views/plugin/plugin-card-buttons-view'
CustomFieldCardDetailBadgesView = require 'app/scripts/views/custom-field/custom-field-card-detail-badges-view'
{ sendPluginScreenEvent, sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
PluginCardDetailBadgesView = require 'app/scripts/views/plugin/plugin-card-detail-badges-view'
StickerView = require 'app/scripts/views/stickers/sticker-view'
CARD_AGING_POWER_UP_ID = require('app/scripts/data/legacy-power-ups').cardAging
Dates = require 'app/scripts/lib/dates'
Confirm = require 'app/scripts/views/lib/confirm'
PopOver = require 'app/scripts/views/lib/pop-over'
PluginSuggestionPopOver = require 'app/scripts/views/plugin/plugin-suggestion-pop-over'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
PluginCardBackSectionView = require 'app/scripts/views/plugin/plugin-card-back-section-view'
{ Noun, Verb, track, trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
CustomFieldsButtonView = require 'app/scripts/views/custom-field/custom-fields-button-view'
CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId
MAP_POWER_UP_ID = require('@trello/config').mapPowerUpId
SetCardLocationPopoverView = require 'app/scripts/views/map/set-card-location-popover-view'
CardLocationView = require 'app/scripts/views/map/card-location-view'
CardAgingPopoverView = require 'app/scripts/views/card-aging/card-aging-popover-view.coffee'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'

module.exports.renderPluginButtons = ->
  subview = @subview PluginCardButtonsView, @model
  @appendSubview subview, @$('.js-plugin-buttons')
  @

module.exports.renderCustomFieldBadges = ->
  subview = @subview CustomFieldCardDetailBadgesView, @model, { sendPluginScreenEvent, sendPluginUIEvent }
  @appendSubview subview, @$('.js-custom-field-detail-badges')
  # only show the section if the Custom Fields Power-Up is enabled and there
  # are some fields defined on the board
  board = @model.getBoard()
  hideSection = !board.isCustomFieldsEnabled() || board.customFieldList.length == 0
  if !hideSection && !@model.editable()
    # hide the section if no custom field item on this card has a value
    hideSection = _.every(@model.customFieldItemList.models, (cfi) -> cfi.isEmpty())
  @$('.js-custom-fields-section').toggleClass('hide', hideSection)
  @

module.exports.renderPluginBadges = ->
  subview = @subview PluginCardDetailBadgesView, @model
  @appendSubview subview, @$('.js-plugin-badges')
  @

module.exports.renderStickers = ->
  $stickers = @$('.js-display-stickers').empty()
  stickers = @model.stickerList.models
  hasStickers = stickers.length > 0
  canRemove = @model.editable()

  if hasStickers
    subviews = (@subview(StickerView, sticker, { board: @model, canRemove }) for sticker in stickers)
    @appendSubviews(subviews, $stickers)

  @checkShowCover()

  @

module.exports.renderAging = ->
  board = @model.getBoard()
  agingActive = board.isPowerUpEnabled('cardAging')
  isEvergreen = @model.getPluginDataByKey(
    CARD_AGING_POWER_UP_ID,
    'card',
    'shared',
    'evergreen',
    false
  )

  $badge = @$('.js-card-detail-age-badge').removeClass @model.getAllAgingClasses()

  if agingActive
    data = @model.getAgingData()

    $badge
    # if date data isn't removed, Dates.formatDate will think nothing changed
    # and won't update.
    .removeData('date')
    .attr('dt', @model.get('dateLastActivity'))

    if data.mode == 'pirate' && !isEvergreen
      $badge.addClass data.agingClassesToAdd

    Dates.update(@$('.js-card-detail-age'))

  @$('.js-card-detail-age').toggleClass('hide', !agingActive)

  @

module.exports.dismissPluginSuggestionSection = (target, idPlugin) ->
  Confirm.toggle 'dismiss plugin suggestion section',
    elem: target
    confirmBtnClass: 'primary'
    fxConfirm: =>
      board = @model.getBoard()
      # store the dismissal in the users private board pluginData
      board.setPluginDataByKey(idPlugin, 'board', 'private', 'dismissedSection', true)
      @renderAttachmentsDebounced()
      # make sure we know about the plugin before generating the event
      board.getAvailablePlugins()
      .then ->
        sendPluginUIEvent({
          idPlugin: idPlugin
          idBoard: board.id
          idCard: @model.id
          event:
            action: 'clicked'
            actionSubject: 'button'
            actionSubjectId: 'dismissPluginSuggestionButton'
            source: 'pluginSuggestionSection'
        })
  return

module.exports.enableSuggestedPluginPrompt = (target, plugin) ->
  PopOver.toggle
    elem: target
    view: new PluginSuggestionPopOver({
      model: plugin
      card: @model
      board: @model.getBoard()
    })
    autoPosition: true
    getViewTitle: => plugin.get('name')

  sendPluginUIEvent({
    idPlugin: plugin.id,
    idBoard: @model.getBoard().id
    idCard: @model.id
    event:
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'enablePluginSuggestionButton'
      source: 'PluginSuggestionSection'
  })
  return

module.exports.renderPluginSections = ->
  @_renderPluginSectionsPromise?.cancel()

  @_renderPluginSectionsPromise = Promise.try =>
    PluginRunner.all
      timeout: 5000
      command: 'card-back-section'
      card: @model
      board: @model.getBoard()
      list: @model.getList()
  .cancellable()
  .then (pluginCardBackSections) =>
    subviews = _.chain(pluginCardBackSections)
      .filter (section) -> pluginValidators.isValidCardBackSection(section)
      .uniq((p) -> p.idPlugin)
      .map (section) =>
        subviewId = "card-back-section_#{section.content.url}_#{section.idPlugin}"
        subview = @subview PluginCardBackSectionView, @model, {}, subviewId
        subview.updateSection(section)
        subview
      .compact()
      .value()

    idPlugins = _.chain(pluginCardBackSections).pluck('idPlugin').uniq().value()
    for idPlugin in idPlugins
      trackUe('card details', 'views', 'Power-Up', '', '', 'card-back-section', idPlugin)

    $pluginSections = @$('.js-plugin-card-back-sections')
    @ensureSubviews(subviews, $pluginSections)

  .catch Promise.CancellationError, (->)

  @_renderPluginSectionsPromise.done()
  @

module.exports.editFieldsSidebar = (e) ->
  Util.preventDefault(e)

  PopOver.toggle
    elem: @$('.js-edit-fields')
    view: CustomFieldsButtonView
    options: { @model, @modelCache, board: @model.getBoard() }

  track("Card Detail", "Sidebar", "Open Custom Fields Menu", @model.trackProperty())
  sendPluginUIEvent({
    idPlugin: CUSTOM_FIELDS_ID
    idBoard: @model.getBoard().id
    idCard: @model.id
    event:
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'powerUpCardButton'
      source: 'cardDetailScreen'
  })
  false

module.exports.editLocationSidebar = (e) ->
  Util.preventDefault(e)

  trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-button', MAP_POWER_UP_ID)
  trackUe(Noun.CARD_DETAILS, Verb.OPENS, 'location menu', '', '', 'by clicking the location sidebar item', {
    idCard: @model.id
    idList: @model.getList().id
    idBoard: @model.getBoard().id
  })
  sendPluginUIEvent({
    idPlugin: MAP_POWER_UP_ID
    idBoard: @model.getBoard().id
    idCard: @model.id
    event:
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'cardMapLocationButton'
      source: 'cardDetailScreen'
  })

  PopOver.toggle
    elem: @$('.js-edit-location')
    view: SetCardLocationPopoverView
    options: { @model, @modelCache, trackingMethod: 'by clicking on the location button' }

  false

module.exports.renderLocation = ->
  isEnabled = @model.getBoard().isMapPowerUpEnabled()

  hideSection = !isEnabled || !@model.get('coordinates')?
  @$('.js-location-section').toggleClass('hide', hideSection)

  if isEnabled && @model.get('coordinates')?
    @cardLocationSubview ?= @subview CardLocationView, @model
    @appendSubview @cardLocationSubview, @$('.js-card-location')
  else if @cardLocationSubview
    @cardLocationSubview.remove()
    @cardLocationSubview = null

  @

module.exports.cardAgingSidebar = (e) ->
  Util.preventDefault(e)
  PopOver.toggle
    elem: @$('.js-card-aging-card-button')
    view: new CardAgingPopoverView({ @model })

  sendPluginUIEvent({
    idPlugin: CARD_AGING_POWER_UP_ID
    idBoard: @model.getBoard().id
    idCard: @model.id
    event:
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'powerUpCardButton'
      source: 'cardDetailScreen'
  })
  false
